<template>
  <div class="row">

    <div class="card col-sm-12" v-if="items">
      <div class="card-header">
        <h4 class="card-title">News</h4>
      </div>
      <div class="card-content">
        <div v-for="item in items" class="col-md-12 card card-plain">
          <a target="_blank" :href="item.link">
            <div class="card-header" style="padding-top: 0px">
              <h4 class="card-title" style="margin-bottom: 0px">{{item.title}}</h4>
              <div class="category">by {{item.creator}}&nbsp;&nbsp;|&nbsp;&nbsp;{{formatDate(item.isoDate)}}</div>
            </div>
            <div class="card-content" style="padding-top: 0px; color: #66615b">{{formatSnippet(item.contentSnippet)}}</div>
          </a>
        </div>
      </div>
    </div>   

  </div>
</template>

<script>
  import moment from 'moment'
  import "isomorphic-fetch"

  export default {
    name: "news",
    components: {},
    data () {
      return {
        rss: null,
        rssLoading: false
      }
    },
    watch: {},
    mounted () {
      this.fetchRSS()
    },
    computed: {
      items() {
        if(this.rss && this.rss.items) {
          return this.rss.items.slice(0, 5);
        } else {
          return null
        }
      }
    },
    methods: {
      async fetchRSS() {
        this.rssLoading = true
        try {
          const data = await fetch('https://www.qualificationcheck.com/feed/')
          if (data.ok) {
            const text = await data.text()
            const parser = new RSSParser()
            parser.parseString(text, (err, parsed) => {
              this.rssLoading = false
              if (err) {
                console.log(`Error occured while parsing RSS Feed ${err.toString()}`)
              } else {
                this.rss = parsed
              }
            })
          } else {
            this.rssLoading = false
            console.log('Error occured while fetching the feed')
          }
        } catch (e) {
          this.rssLoading = false
          if (e.toString() === "TypeError: Failed to fetch") {
             console.log("Error due to CORS policy")
          } else {
             console.log(e.toString())
          }
        }
      },
      formatDate (timestamp) {
        var m = moment(timestamp)
        return m.format('MMM DD, YYYY')
      },
      formatSnippet(snip) {
        snip = snip.replace('[…]','... (read more)')
        snip = snip.substring(0, snip.indexOf('The post '))
        return snip
      }
    }
  }

</script>

<style>

</style>
